
/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/


	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const about = () => `À propos`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const acceptance = () => `Acceptation`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement = () => `Badge`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementImageAltText = (params) => `Graphique du badge pour un ${params.name}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardAnotherCTA = () => `Attribuer un autre`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardCountSummary = (params) => `${params.count} émis.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_heading = () => `Badges revendiqués`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_loginCTA_description = () => `Seuls les membres de cette communauté peuvent consulter les détails du badge. Connectez-vous pour voir les badges.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_badgesClaimed_noneAvailable = () => `Aucune demande n'est disponible pour ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCTA = () => `Revendiquer ce badge`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_claimCountSummary = (params) => `${params.count} personnes détiennent ce badge, mais certains badges peuvent ne pas être visibles s'ils n'ont pas été acceptés.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewDescription = () => `Ajouter une badge dans votre espace est la première étape pour faire reconnaître les valeurs et les compétences qui rassemblent votre communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_createNewHeading = () => `Définir un nouveau badge`




	
/**
 * @param {{ name: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_description = (params) => `Supprimer les badges des membres ${params.name} et ${params.count} ? Cette action ne peut pas être annulée.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_deleteConfirm_heading = () => `Supprimer le badge et tous les demandes associées ?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_editCTA = () => `Modifier le badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_edit_description = () => `Lorsque vous mettez à jour un badge, la nouvelle définition s'appliquera aux membres de la communauté qui l'ont déjà revendiqué ainsi qu'aux futures demandeurs.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown>, timeAgo: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_invitedByNameAtTime = (params) => `Invité par ${params.givenName} ${params.familyName} ${params.timeAgo}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_name = () => `Nom du badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_narrative = () => `Narratif du badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_openClaimable_description = () => `Tout le monde peut revendiquer ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_other = () => `Badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_share_description = () => `Partagez ce badge avec d'autres personnes qui pourraient le revendiquer ou en apprendre davantage à son sujet. Par exemple, vous pouvez afficher ou enregistrer le code QR à ajouter à une présentation pour inviter le public à réclamer un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_youHaveClaimed_description = () => `Votre revendication de ce badge a été acceptée.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_all = () => `tous les badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_description = () => `Les badges affichés par une communauté montrent ce qui compte pour elle.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action_other = () => `Actions`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const adminRoleLabel = () => `Administrateur`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA = () => `Invitation à réclamer`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardBadgeCTA_description = () => `Reconnaître directement un membre de la communauté avec un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardCTA = () => `Offrir`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_createUserIfNotExistsOption = () => `Avancé : forcer la création d'un compte utilisateur pour cet utilisateur s'il n'est pas encore membre`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_description = () => `Vous pouvez soumettre une description des raisons pour lesquelles un membre peut revendiquer ce badge. Elle sera incluse dans le formulaire de demande du badge. S'il existe une URL pointant vers de la documentation ou une preuve qui appuie cette demande, vous pouvez l'inclure.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_narrative_placeholder = () => `Ils ont réalisé un projet...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_noneYet = () => `Pas encore de badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const award_recipientEmail = () => `E-mail du destinataire`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge = () => `Badge décerné`




	
/**
 * @param {{ achievementName: NonNullable<unknown>, communityName: NonNullable<unknown>, badgeUrl: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const awardedBadge_email_description = (params) => `Félicitations, vous avez reçu un badge ${params.achievementName} dans la communauté ${params.communityName}.

Vous pouvez voir votre badge ici et vous connecter pour le mettre à jour :
${params.badgeUrl}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack = () => `Sac à badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyStateCTA = () => `Voir tous les badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_emptyState_description = () => `Découvrez quelques badges disponibles dans cette communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadge = () => `Votre badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_description = () => `Voici les badges que vous avez obtenus dans cette communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_yourBadges_heading = () => `Vos badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_one = () => `badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const badge_other = () => `badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const breadcrumb = () => `Fil d'Ariane`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const cancelCTA = () => `Annuler`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_description = () => `Organisez vos badges par catégorie pour aider votre communauté à voir ce qui va ensemble et ce qui est le plus important.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_editCTA = () => `Modifier les catégories`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const categories_title = () => `Catégories de badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category = () => `Catégorie`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_achievementCount = () => `Nombre de badges`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_name = () => `Nom de catégorie`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_other = () => `Catégories`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const category_weight = () => `Importance`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_cancelFailError = () => `Erreur lors du stockage du badge. L'opération a échoué ou a été annulée par l'utilisateur. Aucun autre détail n'est disponible.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_description = () => `Afin de partager vos badges entre différentes communautés et autres sites où vous utilisez des badges, vous pouvez les envoyer vers un portefeuille. Cette application prend en charge les portefeuilles compatibles avec`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_noPolyfillError = () => `Aucun Credential Handler Polyfill n'est actif dans ce navigateur.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chapi_walletSignupCTA_description = () => `Si vous n'avez pas encore de portefeuille compatible, vous pouvez vous inscrire pour un nouveau portefeuille avec`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimCTA = () => `Revendiquer`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_adminOnly_description = () => `Ce badge ne peut être attribué que par les administrateurs de la communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_allow = () => `Autoriser la demande de badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimDisabled = () => `Non revendiquable`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimEnabled = () => `Demande de badge activée`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_claimRequiresSummary = () => `Ce badge peut être revendiqué par les membres titulaires d'un badge pour :`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_heading = () => `Configuration de la demande de badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_noReviewsRequired_description = () => `Les demandes de badge sont valides immédiatement et ne nécessitent aucun examen.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_openClaimableCTA = () => `Revendiquer pour rejoindre la communauté`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_relatedAchievementNotFoundError = () => `Impossible d'enregistrer les paramètres de ce badge. Le badge associée requis n'a pas été trouvé.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement = () => `Badge requis pour revendiquer ce badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_requiredAchievement_description = () => `Saisissez une badge qu'un membre doit déjà détenir pour pouvoir revendiquer ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires = () => `Badge requis pour valider les demandes de badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewRequires_description = () => `Saisissez une badge requis pour être examinateur (endosseur qualifié) des demandes de badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired = () => `Nombre d'examens requis (jusqu'à 5)`




	
/**
 * @param {{ reviewsRequired: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequiredSummary = (params) => `Les badges doivent être examinées par les membres ${params.reviewsRequired} qui détiennent le badge :`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_reviewsRequired_description = () => `Saisir le nombre d'examens requis pour qu'une demande de badge soit validée. En choisissant « 0 », elles seront immédiatement valides.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_unexpectedSaveError = () => `Un problème inattendu lors de l'enregistrement de la configuration du badge s'est produit.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userMeetsRequirement = () => `Vous remplissez cette condition.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetRequirement_heading = () => `Non admissible`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_userNotMeetsRequirement = () => `Vous ne détenez pas encore ce prérequis.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrativeInstructions = () => `Décrivez en quelques phrases ce que vous avez réalisé ou envisagez de réaliser.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_description = () => `Vous pouvez soumettre une description de la raison pour laquelle vous remplissez les conditions requises pour ce badge. Elle sera incluse dans votre badge. S'il existe une URL qui renvoie à une documentation de cette réalisation sur le web, vous pouvez aussi l'inclure.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimForm_narrative_placeholder = () => `J'ai réalisé un projet...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_achievementNotClaimableError = () => `Ce badge ne peut être revendiqué.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeCTA = () => `Afficher ou modifier vos paramètres de badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_changeRejectedToAcceptedCTA = () => `Acceptation du changement : accepter le badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimBadgeCTA = () => `Revendiquer le badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_claimedByAnonMember = () => `Ce badge a été revendiqué par un membre de la communauté. Voir les détails ci-dessous.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_couldNotObtainInvitationError = () => `Impossible d'obtenir une invitation pour revendiquer ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_editCTA = () => `Modifier le badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationEmailReconciliationError = () => `L'invitation n'a pas pu être rapprochée de l'e-mail des utilisateurs.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_invitationInvalidError = () => `Invitation invalide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_noExistingFoundError = () => `Aucune badge existant trouvé.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundError = () => `Badge introuvable.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_notFoundOrNotShareableError = () => `Le badge est introuvable ou ne peut pas être partagé.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_rejectCTA = () => `Rejeter`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_sendToWalletCTA = () => `Envoyer vers le portefeuille`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareCTA = () => `Partager ce badge`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareText_heading = (params) => `J'ai revendiqué un badge, ${params.name}.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_shareUrlCopied = () => `URL de partage copiée dans le presse-papiers :`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAccepted = () => `Revendiquation acceptée.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusAcceptedPublic = () => `Ce badge a été accepté par le destinataire.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited = () => `Vous êtes invité à revendiquer un badge`




	
/**
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvitedFull_description = (params) => `Vous avez été invité à réclamer un badge le ${params.createdOn}, mais vous ne l'avez pas encore accepté. Vous pouvez le revendiquer maintenant ou le rejeter. Si vous souhaitez le mettre à jour ou le documenter, vous pouvez le faire.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusInvited_description = () => `Vous avez été invité à revendiquer un badge, mais vous n'avez pas encore accepté l'invitation.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected = () => `Badge refusé`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejectedPublic_description = () => `Ce badge n'a pas été accepté par le destinataire. Veuillez vérifier auprès d'eux pour plus d'informations.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusRejected_description = () => `Vous avez refusé ce badge. Il n'apparaîtra pas sur votre profil et ne pourra pas être téléchargé.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUnacceptedPublic = () => `Ce badge n'a pas encore été accepté par le destinataire. Veuillez revenir plus tard.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted = () => `Vous avez accepté ce badge`




	
/**
 * @param {{ createdOn: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusUserAccepted_description = (params) => `Vous avez obtenu ce badge le ${params.createdOn}. Il est visible par les autres membres de la communauté. Vous pouvez documenter et ajouter des détails à votre badge. Vous pouvez également modifier votre acceptation si vous ne souhaitez plus conserver ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidNoReviewRequired = () => `Ce badge ne nécessite aucun examen et est valide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_statusValidSufficientReviews = () => `Ce badge a reçu suffisamment d'examens positifs et est valide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedError = () => `Ce badge ne peut être revendiqué par des utilisateurs non authentifiés.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_unauthenticatedUserEndorsementError = () => `Les utilisateurs non authentifiés ne peuvent pas endosser ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_userNotMeetsPrerequsiteError = () => `Vous n'avez pas le badge prérequis pour revendiquer à ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validFrom = () => `Valable depuis le`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_validUntil = () => `Valable jusqu'au`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_viewCTA = () => `Consulter la demande de badge`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveAwarded = (params) => `Vous avez attribué ce badge à ${params.givenName} ${params.familyName}.`




	
/**
 * @param {{ inviteeEmail: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_youHaveInvited = (params) => `Vous avez créé une invitation pour ${params.inviteeEmail}. Ils peuvent rejoindre la communauté en revendiquant ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claim_yourPreferredEmail = () => `Votre e-mail préféré`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimed = () => `Revendiqué`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clipboard_couldNotCopyError = () => `Impossible de copier automatiquement dans le presse-papiers. Votre navigateur peut ne pas prendre en charge cela ou la page peut ne pas être diffusée via HTTPS.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const close = () => `Fermer`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contactCTA = () => `Contact`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const contentMissing = () => `Contenu manquant`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const copyCTA = () => `Copier`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const createNewCTA = () => `Créer nouveau`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria = () => `Critères`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_description = () => `Définissez ce qui doit être fait pour obtenir ce badge. Vous pouvez faire référence à une page Web externe si nécessaire.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_placeholder = () => `* Faire preuve de sa capacité à prendre des initiatives en...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const criteria_url = () => `URL des critères`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date = () => `Date`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const deleteCTA = () => `Supprimer`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const description = () => `Description`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const downloadCTA = () => `Télécharger`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const earnedBadge = () => `Badge obtenu`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const editCTA = () => `Modifier`




	
/**
 * @param {{ message: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const email_transmissionError = (params) => `Erreur lors de l'envoi de l'e-mail : ${params.message}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseFormCTA = () => `Endosser le badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_alreadyRecommendedError = () => `Vous avez déjà endossé cette personne pour ce badge. Les données précédentes sont présentées ci-dessous.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_description = (params) => `Ajoutez votre endossement au badge de ${params.givenName} ${params.familyName}.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorseForm_narrative_description = () => `Vous pouvez ajouter votre endossement sur la façon dont ce membre se qualifie pour ce badge. Il sera inclus dans la remise du badge. S'il existe une URL pointant vers une documentation ou preuve, vous pouvez l'inclure.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_addYoursCTA = () => `Ajoutez le vôtre`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_couldNotIdentifyEmailAddressError = () => `Impossible d'identifier une adresse e-mail. Vous pouvez faire cet endossement par e-mail à partir de la page du badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_other = () => `Endossements`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const endorsement_updateCTA = () => `Mettez à jour votre endossement`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error = () => `Erreur`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error_unauthorized = () => `Non autorisé`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const evidenceURL = () => `URL de la documentation/preuves`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const familyName = () => `Nom de Famille`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const givenName = () => `Prénom`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home = () => `Page d'accueil`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel = () => `identifiant`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const identifierListLabel_other = () => `identifiants`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const image = () => `Image`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm = () => `Êtes-vous sûr de vouloir refuser ce badge ?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invitation_rejectConfirm_description = () => `Si vous refusez ce badge, il ne sera pas affiché sur votre profil ni vérifiable. Vous pourrez changer d'avis par la suite.`




	
/**
 * @param {{ name: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteJoinCTA_description = (params) => `Vous avez été invité à revendiquer un badge et à rejoindre la communauté ${params.name}. Confirmez votre e-mail pour continuer.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_achievementUnauthorizedError = () => `Vous ne pouvez pas attribuer ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_notFoundError = () => `Invitation inconnue. Cette invitation n'existe pas ou n'est peut-être plus valide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_recipientIdentifierRequiredError = () => `L'identifiant du destinataire est requis.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const invite_unauthorizedNonAdminError = () => `Vous ne pouvez pas inviter d'autres personnes à revendiquer ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const linkedin_addToProfileButton_label = () => `Bouton Ajouter au profil LinkedIn`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logInCTA = () => `Se connecter`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const logOutCTA = () => `Se déconnecter`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginCTA_description = () => `Si vous êtes enregistré comme membre, vous pouvez vous connecter pour gérer les reconnaissances dans cette communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA = () => `Connectez-vous pour accepter l'invitation`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const loginInviteCTA_description = () => `Vous avez été invité à revendiquer un badge et à rejoindre la communauté. Complétez votre inscription pour continuer.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_agreeTermsError = () => `Vous devez accepter les conditions pour rejoindre la communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_checkEmailCTA_description = () => `Vérifiez votre courrier électronique pour votre code de vérification.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailNotParsedError = () => `Vous devez saisir une adresse e-mail valide pour vous connecter.`




	
/**
 * @param {{ code: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_emailVerificationCodeIs = (params) => `Votre code de vérification est : ${params.code}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_incorrectCodeError = () => `Code incorrect.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_invitationRequiredError = () => `Impossible de se connecter avec cette adresse e-mail sans avoir reçu une invitation. Vérifiez votre courrier électronique pour un lien d'invitation.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_sendCodeCTA = () => `Envoyer le code`




	
/**
 * @param {{ orgName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_toCommunityNameCTA = (params) => `Connectez-vous à ${params.orgName}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_verificationCodeRequiredError = () => `Un code de vérification est requis.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const markdown_description = () => `Vous pouvez formater le texte en utilisant Markdown.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const me = () => `moi`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const media_localMediaOnlyAvailableInDevError = () => `Les médias locaux ne sont disponibles que pour les environnements de développement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member = () => `Membre`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_memberDetailsLabel = () => `Profil détaillé`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_notFoundError = () => `Membre de la communauté introuvable avec cet identifiant.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_other = () => `Membres`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_otherUserProfileDescription = () => `Un utilisateur associé à cette communauté`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_settingsChangeUnauthenticedError = () => `Seuls les utilisateurs authentifiés peuvent modifier les paramètres.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_share_description = () => `Vous pouvez partager une URL vers votre profil, où d'autres personnes peuvent voir les badges que vous avez gagnés. Il ne sera visible que par les autres membres de la communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const member_yourProfileGreeting = () => `Ceci est votre profil.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_description = () => `Utilisateurs associés à cette communauté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const members_title = () => `Membres de la communauté`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const membership = () => `Adhésion`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const mostAwardedAchievements = () => `Badges les plus revendiqués`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const narrative = () => `Narratif`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const notFound = () => `Introuvable`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_editCTA = () => `Modifier l'organisation`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_edit_description = () => `En tant qu'administrateur de la communauté, vous pouvez mettre à jour les informations qui la décrivent.`




	
/**
 * @param {{ orgName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin = (params) => `Invitation à rejoindre ${params.orgName}`




	
/**
 * @param {{ achievementName: NonNullable<unknown>, orgName: NonNullable<unknown>, inviteLink: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_inviteToJoin_description = (params) => `Vous avez été invité à revendiquer le badge ${params.achievementName}

En revendiquant ce badge, vous pouvez rejoindre la communauté ${params.orgName}. Cliquez ici pour la rejoindre :

${params.inviteLink}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_name = () => `Nom de l'organisation`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_primaryColor = () => `Couleur primaire`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_url = () => `Page d'accueil de la communauté :`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const org_usesOrca = () => `Cette communauté utilise ORCA pour reconnaître les personnes et leurs compétences`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const organization_notFoundError = () => `Communauté ORCA introuvable.`




	
/**
 * @param {{ givenName: NonNullable<unknown>, familyName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const otherUserBadge_heading = (params) => `Le badge de ${params.givenName} ${params.familyName}`




	
/**
 * @param {{ page: NonNullable<unknown>, maxPage: NonNullable<unknown>, count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const paginationSummary = (params) => `Page ${params.page} sur ${params.maxPage} (${params.count} résultats au total)`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const previewCTA = () => `Aperçu`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const privacyPolicy = () => `Politique de confidentialité`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile = () => `Profil`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile_editCTA = () => `Modifier les paramètres`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const qrCode = () => `QR code`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_genericError = () => `Impossible de s'inscrire. Essayez de vous connecter à nouveau.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const requirement_statusInvalid = () => `Requête invalide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const saveCTA = () => `Sauvegarder`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const seeCTA = () => `Voir`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const session_invalidError = () => `Session invalide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const setting_other = () => `Paramètres`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share = () => `Partager`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_copyUrl = () => `Copy URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_description = () => `Vous pouvez copier l'URL publique de votre badge pour le partager via les réseaux sociaux, l'importer dans d'autres sacs à badges, envoyer des e-mails ou l'inclure sur votre CV.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_description = () => `Affichez ce code QR ou enregistrez-le sur votre appareil pour partager votre badge avec d'autres personnes, par exemple en invitant quelqu'un à vous soutenir.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCode_heading = () => `Partager par QR code`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const share_qrCodeImageAltText = () => `Une image QR Code qui peut être numérisée avec un téléphone ou un scanner`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status = () => `Condition`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_accepted = () => `Accepté`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_created = () => `Créé`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited = () => `Invité`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_description = () => `Vous avez été invité à revendiquer ce badge, mais vous n'avez pas accepté.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_invited_medium = () => `Vous avez été invité à revendiquer ce badge`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_loading = () => `Chargement...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed = () => `Ce badge est toujours en cours d'examen.`




	
/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_notYetReviewed_description = (params) => `Pas encore examiné. Ce badge est valide une fois qu'il accumule ${params.count} endossements par les détenteurs du badge :`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_prerequisiteRequired = () => `Prérequis`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected = () => `Rejeté`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_rejected_description = () => `Vous avez été invité à revendiquer ce badge, mais vous avez rejeté cette invitation. Aucun autre membre de la communauté ne verra que vous avez été invité à revendiquer ce badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_underReview = () => `En cours d'examen`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_valid = () => `Valide`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const status_verified = () => `vérifié`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const submitCTA = () => `Soumettre`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tagline = () => `Puissiez-vous être compétent dans vos activités aujourd'hui.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const termsOfService = () => `Conditions d'utilisation`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const themeCTA_description = () => `Basculer l’interface entre les modes clair et sombre.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tos_agreementCTA_description = () => `J'accepte les conditions d'utilisation et la politique de confidentialité de cette communauté`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const unauthenticatedError = () => `Non authentifié`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const uncategorized = () => `Non classé`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const url = () => `URL`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const verificationCode = () => `Le code de vérification`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view = () => `Voir`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const writeCTA = () => `Écrire`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const yourEmail = () => `Votre adresse e-mail`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const removeCTA = () => `Retirer`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const changeCta = () => `Changement`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_selectThisCTA = () => `Sélectionnez cette réalisation`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_searchByName = () => `Rechercher des réalisations par nom`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound = () => `Aucune réalisation trouvée.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_noneFound_description = () => `Cette communauté n'a aucune réalisation visible.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorLoading = () => `Erreur lors du chargement des succès`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requireAReview = () => `Exiger un examen avant que les récompenses ne soient valides`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_chooseCTA = () => `Choisissez la réalisation`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_anAdminReviewRequired = () => `Les réclamations doivent être examinées par un administrateur.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const inviteRequires_notFound = () => `Succès requis pour inviter introuvable.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiredCrossValidationMessage = () => `Un badge doit être sélectionné si un examen par un titulaire est requis.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievement_awardByInvitation = () => `Non réclamable. Remise sur invitation uniquement.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabel = () => `Une révision est-elle nécessaire ?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_reviewRequiresLabelSpecific = () => `Revu par les titulaires d'un badge spécifique : `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiresLabel = () => `Qui peut inviter des personnes à réclamer un badge ?`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_requirementHoldersOf = () => `Titulaires d'un badge spécifique : `




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const chooseCTA = () => `Choisir...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const backpack_errorFetchingData = () => `Erreur lors de la récupération des données du sac à dos !`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievements_errorFetchingData = () => `Erreur lors de la récupération des succès !`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_claimRequiresCrossValidationMessage = () => `Un badge doit être sélectionné si la réclamation nécessite un badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteREquiresCrossValidationMessage = () => `Un badge doit être sélectionné si un examen sur invitation est requis.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const achievementConfig_inviteRequiredGeneric = () => `Cette réalisation n'est décernée que sur invitation.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const claimConfiguration_inviteRequiresDescription = () => `Les invitations à réclamation peuvent être formulées par les titulaires de :`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const authentication_couldNotLogIn = () => `Impossible de se connecter.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bad_bold_shrimp_express = () => `Date`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tense_raw_cuckoo_dart = () => `Vous ne pouvez pas inviter d'autres personnes à revendiquer ce badge, car votre badge de qualification n'est pas encore valide.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const known_such_scallop_gaze = () => `Rejeter`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const proof_funny_dog_pat = () => `Accepter`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sunny_grand_lemur_race = () => `Adresse email invalide`




	
/**
 * @param {{ achievementName: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const dull_bright_ostrich_delight = (params) => `Image du badge ${params.achievementName}`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const merry_trite_seahorse_relish = () => `Vous détenez un badge pour cette réussite.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gray_fluffy_myna_pet = () => `Révisé par un administrateur`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const aqua_alive_cougar_tickle = () => `Uniquement les administrateurs`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const home_vivid_mole_gaze = () => `Vous pouvez contrôler la manière dont votre profil est affiché aux autres utilisateurs de la communauté et la manière dont vos informations d'identification vous sont transmises.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const nice_active_giraffe_propel = () => `Identifiant`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const warm_male_thrush_pout = () => `Taper`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const clear_crazy_meerkat_nurture = () => `Visibilité`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const short_deft_lemur_clasp = () => `Public`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const equal_small_dolphin_spur = () => `Réservé aux membres de la communauté`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pink_last_marten_grin = () => `Privé (administrateurs uniquement)`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const best_sweet_termite_work = () => `Qui peut voir les badges que vous avez gagnés par défaut ? Vous pouvez choisir de modifier cette option pour chaque badge.`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const direct_plane_boar_succeed = () => `Visibilité du badge par défaut`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const every_flat_lamb_favor = () => `Choisir...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const fancy_antsy_ray_gaze = () => `Non`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const tired_top_fish_bask = () => `Réclamable par les détenteurs d'un badge spécifique :`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const factual_agent_mantis_jump = () => `Erreur inconnue`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const elegant_free_cow_cherish = () => `Ce qui rend cette communauté spéciale, c'est...`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const grand_tangy_cheetah_buy = () => `Slogan`




	
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const moving_east_okapi_shrine = () => `Célébrez vos compétences au sein de la communauté.`

